<template>
    <div class="table">
        <div class="crumbs" style="float:left">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{ menuName }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div style="float:right;color:red;font-size: 16px;"">
            累计使用存储空间：{{ sumFileSizeLabel }}
        </div>
        <!-- 列表数据 -->
        <div class=" container" style="float:right;width:95%;">
            <div style="height:75px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <el-select v-model="form.deptId" @change="getTemplates" placeholder="请选择学校">
                        <el-option v-for="item in depts" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-input v-model="form.title" placeholder="作业标题" style="width:130px;"></el-input>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-input v-model="form.createName" placeholder="发布者" style="width:100px;"></el-input>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-date-picker v-model="form.startDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                        style="width: 150px;" type="date" placeholder="开始日期" @change="startDateChangeEvent">
                    </el-date-picker>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-date-picker v-model="form.endDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                        style="width: 150px;" type="date" placeholder="结束日期">
                    </el-date-picker>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-select v-model="form.taskType" clearable style="width:160px;" @change="changeTaskType"
                        placeholder="请选择任务类型">
                        <el-option v-for="item in taskTypes" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div style="display: inline-block; height:40px;" v-if="form.taskType == 2">
                    <el-select v-model="form.templateId" clearable @change="getTemplateTasks" placeholder="请选择模板">
                        <el-option v-for="item in templates" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div style="display: inline-block; height:40px;" v-if="form.taskType == 2">
                    <el-select v-model="form.templateTaskId" clearable placeholder="请选择任务模板">
                        <el-option v-for="item in templateTasks" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1; getData()">查询</el-button>
                    <el-button type="success" icon="el-icon-download" @click="exportExcel">导出Excel</el-button>
                </div>
            </div>

            <el-table :data="data" style="width: 100%;margin-bottom: 20px;" row-key="id" v-loading="loading"
                :element-loading-text="loadingText" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)" border default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column label="作业标题" :show-overflow-tooltip="true" width="230">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="showDataInfo(scope.row)">
                            {{ scope.row.title }}
                            <span v-if="scope.row.taskType == 1" style="font-size: 10px; color: red;">（#布置作业）</span>
                            <span v-else-if="scope.row.taskType == 2"
                                style="font-size: 10px; color: red;">（#打卡任务）</span>
                            <span v-else-if="scope.row.taskType == 3"
                                style="font-size: 10px; color: red;">（#写实记录）</span>
                            <span v-else-if="scope.row.taskType == 4"
                                style="font-size: 10px; color: red;">（#个人总结）</span>
                            <span v-else-if="scope.row.taskType == 5"
                                style="font-size: 10px; color: red;">（#典型案例）</span>
                            <span v-else-if="scope.row.taskType == 6"
                                style="font-size: 10px; color: red;">（#德育奖惩）</span>
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="作业内容" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="className" label="班级名称" :show-overflow-tooltip="true"
                    width="80"></el-table-column>
                <el-table-column prop="createName" label="发布者" width="80"></el-table-column>
                <el-table-column prop="gmtCreate" label="发布时间" width="140"></el-table-column>
                <el-table-column fixed="right" label="操作" width="95px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button v-if="(currentUserId == scope.row.createBy || currentUserId == 1)" style="color: red" @click.native.prevent="del(scope.row)" type="text" size="small">
                            删除
                        </el-button>
                        <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)">
                            <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="handleStudentTask"
                                    icon="el-icon-circle-check">学生作业详情</el-dropdown-item>
                                <el-dropdown-item command="handleFineTask" v-if="scope.row.fineCount > 0"
                                    icon="el-icon-circle-check">优秀作业详情</el-dropdown-item>
                                <el-dropdown-item command="handleDownloadFiles" v-if="scope.row.fileCount > 0"
                                    icon="el-icon-download">下载学生作业附件</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="common.page" :page-size="common.pageSize" :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper" :total="common.total">
                </el-pagination>
            </div>
        </div>

        <!-- 查看优秀名单弹出框 -->
        <div v-if="fineTaskNameVisible">
            <fineTaskName ref="fineTaskName"></fineTaskName>
        </div>
        <!-- 添加发布作业详情弹出框 -->
        <show-tasklist-details v-model="showTasklistDetailsVisible" :tasklist="selectTasklist" />
        <!-- 学生作业详情弹出框-作业 -->
        <div v-if="studentTaskVisible">
            <studentTask ref="studentTask"></studentTask>
        </div>
        <!-- 学生作业详情弹出框-打卡 -->
        <div v-if="studentClockinTaskVisible">
            <studentClockinTask ref="studentClockinTask"></studentClockinTask>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import http from '../../../common/http';
import studentTask from './StudentTask.vue';
import studentClockinTask from './StudentClockinTask.vue';
import fineTaskName from './FineTaskName.vue';
import showTasklistDetails from './components/showTasklistDetails.vue';

export default {
    name: "TaskList",
    data() {
        return {
            menuName: "",
            studentTaskVisible: false,
            fineTaskNameVisible: false,
            showTasklistDetailsVisible: false,
            studentClockinTaskVisible: false,
            loading: false,
            loadingText: "",
            common: {
                total: 0,            //总数据量
                pageSize: 30,        //每页条数
                page: 1,              //页码
                isPage: 1,            //是否分页
                allSizes: [30, 50, 100], //每页条数筛选
                checkboxArr: []       //多选框数组
            },
            form: {
                deptId: "",
                taskType: "",
                templateId: "",
                templateTaskId: "",
                createName: "",
                title: "",
                startDate: "",
                endDate: ""
            },
            taskTypes: [{
                value: 1,
                label: '布置作业'
            }, {
                value: 2,
                label: '打卡任务'
            }, {
                value: 3,
                label: '写实记录'
            }, {
                value: 4,
                label: '个人总结'
            }, {
                value: 5,
                label: '典型案例'
            }, {
                value: 6,
                label: '德育奖惩'
            }],
            depts: [],
            data: [],
            templates: [],
            templateTasks: [],
            selectTasklist: {},
            // 累计使用存储空间
            sumFileSizeLabel: "",
            timer: undefined,
            // 当前用户id
            currentUserId:""
        }
    },
    components: {
        studentTask, fineTaskName, showTasklistDetails, studentClockinTask
    },
    created: function () {
        this.menuName = sessionStorage.getItem("selectMenuItem_key")
        this.getDeptData()
        // 用户信息
        let userinfo =JSON.parse(sessionStorage.getItem('userinfo'));
        // 获取当前用户id
        if (userinfo != null && userinfo != "") {
            this.currentUserId = userinfo.id;
        }
    },
    methods: {
        indexMethod(index) {
            return (this.common.page - 1) * this.common.pageSize + (index + 1);
        },
        // 查询部门信息
        getDeptData() {
            //部门管理
            let url = this.listDeptUrl
            let data = { parentId: "0" }
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.depts = res.data.list
                    if (this.depts.length > 0) {
                        this.form.deptId = this.depts[0].id
                    }
                    this.getTemplates()
                    this.getData()
                    // 定时刷新累计使用的存储空间
                    this.timer = setInterval(() => {
                        this.getSumFileSizeByGroupType();
                    }, 5000);
                } else {
                    this.$commonFn.showTip(res.message, 3)
                }
            }, (err) => {
                console.log(err)
            });
        },
        // 获取各类文件总和
        getSumFileSizeByGroupType() {
            let url = this.taskLisfileSumFileSizeByGroupTypesUrl
            let data = {
                deptId: this.form.deptId
            };
            this.apiPost(url, data).then((res) => {
                console.log('文件总和', res.data)
                if (res.status == 200) {
                    let sumFileSizeLabel = ""
                    for (let i = 0; i < res.data.length; i++) {
                        let tempData = res.data[i]
                        // 文件类型（1-图片、2-录音、3-视频、4-链接）
                        if(this.$util.isNotEmpty(sumFileSizeLabel)){
                            sumFileSizeLabel+="，"
                        }
                        if (tempData.fileType == 1) {
                            sumFileSizeLabel=sumFileSizeLabel+'图片'+tempData.fileSumSize
                        } else if (tempData.fileType === 2) {
                            sumFileSizeLabel=sumFileSizeLabel+'录音'+tempData.fileSumSize
                        } else if (tempData.fileType === 3) {
                            sumFileSizeLabel=sumFileSizeLabel+'视频'+tempData.fileSumSize
                        }
                    }
                    this.sumFileSizeLabel = sumFileSizeLabel
                } else {
                    this.$commonFn.showTip(res.message, 3)
                }
            }, (err) => {
                console.log(err);
            });
        },
        // 获取模板列表
        getTemplates() {
            let url = this.clockinTemplateGetTemplatesUrl;
            let data = {
                deptId: this.form.deptId
            };
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.templates = res.data;
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
            });
        },
        // 任务类型切换
        changeTaskType() {
            this.form.templateId = ""
            this.form.templateTaskId = ""
        },
        // 获取任务模板列表
        getTemplateTasks() {
            this.templateTasks = []
            if (this.$util.isEmpty(this.form.templateId)) {
                return
            }

            let url = this.clockinTemplateTaskGetTemplateTasksUrl
            let data = {
                deptId: this.form.deptId,
                templateId: this.form.templateId
            }
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.templateTasks = res.data
                } else {
                    this.$commonFn.showTip(res.message, 3)
                }
            }, (err) => {
                console.log(err)
            });
        },
        // 获取列表信息
        getData() {
            // 刷新累计使用的存储空间
            this.getSumFileSizeByGroupType()

            this.loading = true;
            this.loadingText = "正在加载中...";

            let startDate = this.$util.isEmpty(this.form.startDate) ? "" : this.form.startDate
            let endDate = this.$util.isEmpty(this.form.endDate) ? "" : this.form.endDate

            let url = this.taskListUrl;
            let data = {
                isPage: this.common.isPage,
                page: this.common.page,
                limit: this.common.pageSize,
                taskType: this.form.taskType,
                deptId: this.form.deptId,
                templateId: this.form.templateId,
                templateTaskId: this.form.templateTaskId,
                createName: this.form.createName,
                title: this.form.title,
                startDate: startDate,
                endDate: endDate,
            };
            // console.log(JSON.stringify(data))
            // return;
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.data = res.data.list;
                    this.common.total = res.data.total;
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
                this.loading = false;
            }, (err) => {
                this.loading = false;
            });
        },
        handleSizeChange(val) {
            this.common.pageSize = val;
            this.common.page = 1;
            this.getData();
        },
        handleCurrentChange(val) {
            this.common.page = val;
            this.getData();
        },
        //删除
        del(data) {
            this.form.id = data.id;
            this.$commonFn.showConfirm(this.delSuccess);
        },
        delSuccess() {
            let url = this.taskListRemoveUrl;
            let data = {
                id: this.form.id
            };
            this.apiPost(url, data).then((res) => {
                if (res.status === 200) {
                    this.$commonFn.showTip(res.message, 1);
                    this.getData();
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
            })
        },
        // 更多操作触发
        handleCommand(command, row) {
            switch (command) {
                case "handleStudentTask":
                    this.setReceive(row)
                    break;
                case "handleFineTask":
                    this.setFineTask(row)
                    break;
                case "handleDownloadFiles":
                    this.downloadFiles(row);
                    break;
                default:
                    break;
            }
        },
        startDateChangeEvent() {
            this.form.endDate = "";
        },
        showDataInfo(data) {
            this.selectTasklist = data
            this.showTasklistDetailsVisible = true
        },
        setReceive(row) {
            if (row.taskType === 1) {
                this.studentTaskVisible = true;
                this.$nextTick(() => {
                    this.$refs['studentTask'].init(this.form.deptId, row);
                })
            } else {
                this.studentClockinTaskVisible = true;
                this.$nextTick(() => {
                    this.$refs['studentClockinTask'].init(this.form.deptId, row);
                })
            }
        },
        setFineTask(row) {
            this.fineTaskNameVisible = true;
            this.$nextTick(() => {
                this.$refs['fineTaskName'].init(this.form.deptId, row.id);
            })
        },
        exportExcel() {
            const maxCount = 65535
            if (this.common.total > maxCount) {
                let msg = "导出数据超出" + maxCount + "条平台不支持，请缩小数据范围查询，然后再进行导出操作！"
                this.$commonFn.showTip(msg, 3)
            } else {
                this.exportData()
            }
        },
        exportData() {
            this.loading = true;
            this.loadingText = "正在导出中，导出过程时间可能会比较长，请耐心等待";

            let url = this.taskExportExcelUrl;
            console.log("url:" + url);
            let param = new URLSearchParams();
            param.append('deptId', this.form.deptId);
            param.append('taskType', this.form.taskType);
            param.append('templateId', this.form.templateId);
            param.append('templateTaskId', this.form.templateTaskId);
            param.append('createName', this.form.createName);
            param.append('title', this.form.title);
            param.append('startDate', this.$util.isEmpty(this.form.startDate) ? "" : this.form.startDate);
            param.append('endDate', this.$util.isEmpty(this.form.endDate) ? "" : this.form.endDate);

            axios({
                method: "post",
                url: url,
                data: param,
                responseType: "blob"
            }).then(res => {
                const link = document.createElement("a");
                let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                link.style.display = "none";
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", '实践评价.xls');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.loading = false;
            }).catch(error => {
                console.log(error);
                this.loading = false;
            });
        },
        downloadFiles(row) {
            this.loading = true;
            this.loadingText = "正在下载中，下载过程时间可能会比较长，请耐心等待";

            let url = this.taskListDownloadZipFileUrl;
            let param = new URLSearchParams();
            param.append('taskListId', row.id);

            axios({
                method: "post",
                url: url,
                data: param,
                responseType: "blob"
            }).then(res => {
                let data = res.data
                var blob = new Blob([data])
                // 创建下载的链接
                var a = document.createElement('a');
                a.style.display = 'none';
                var href = window.URL.createObjectURL(blob);
                a.href = href;
                //显示下载文件名 获取后端返回的文件名
                let filename = res.headers['content-disposition'].split('=')[1]
                // 文件名中有中文 则对文件名进行转码 decodeURI
                a.download = decodeURI(filename)
                // 利用a标签做下载       
                document.body.appendChild(a);
                // 点击下载
                a.click();
                // 下载后移除元素
                document.body.removeChild(a);
                // 释放掉blob对象
                window.URL.revokeObjectURL(href);
                this.loading = false;
            }).catch(error => {
                console.info('response.error' + error.message);
                this.loading = false;
            });
        }
    },
    destroyed() {
        if(this.timer!=undefined){
            clearInterval(this.timer);
        }
        console.log("实践作业destroy函数执行");
    },
    mixins: [http]
}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/task/TaskList.vue